export const LOAD_PATIENT_HOME_Q = 'LOAD_DTT_QUESTIONNAIRE_FOR_PATIENT_HOME';
export const LOAD_PATIENT_HOME_Q_RESPONSE = 'LOAD_DTT_QUESTIONNAIRE_RESPONSE_FOR_PATIENT_HOME';
export const QUESTIONNAIRE_RESPONSE = 'STORE_QUESTIONNAIRE_RESPONSE';
export const PARSE_RESPONSE = 'PARSE_RESPONSE';
export const DTT_PARSE_RESPONSE = 'DTT_PARSE_RESPONSE_FOR_PATIENT_HOME';
export const FETCHING_RESPONSE = 'FETCHING_RESPONSE';
export const FETCHING_EMPTY_Q = 'FETCHING_RESPONSE';
export const RESET_QUESTIONNAIRE = 'RESET_QUESTIONNAIRE';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';
export const ON_QUESTIONNAIRE_LOADED = 'LOAD_QUESTIONNAIRE_AND_RESPONSE';

// Reference for how we could store this state
// Delete after Recommendations epic is completed
// const x= {
//   questionaires: [],
//   responses: [],
//   curentQuestionnaire: 1,
// }

const initialState = {
  DTT: null,
  DTTResponse: null,
  DTTParsedResponse: null,
  current: null,
  response: null,
  parsedResponse: null,
  fetching: false,
  fetched: false,
  fetchingEmptyQ: false,
  fetchedEmptyQ: false,
  newPatient: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PATIENT_HOME_Q:
      return {
        ...state,
        fetchingEmptyQ: false,
        fetchedEmptyQ: true,
        DTT: action.payload,
      };
    case LOAD_PATIENT_HOME_Q_RESPONSE:
      if (typeof action.payload === 'undefined') {
        return {
          ...state,
          fetched: true,
          fetching: false,
          newPatient: true,
          DTTResponse: null,
        };
      }
      return {
        ...state,
        fetched: true,
        fetching: false,
        newPatient: false,
        DTTResponse: action.payload,
      };
    case ON_QUESTIONNAIRE_LOADED:
      return {
        ...state,
        fetchingEmptyQ: false,
        fetchedEmptyQ: true,
        current: action.payload,
      }
    case FETCHING_EMPTY_Q:
      return {
        ...state,
        fetchingEmptyQ: true,
      };
    case FETCHING_RESPONSE:
      return {
        ...state,
        fetching: true,
        newPatient: false,
      };
    case QUESTIONNAIRE_RESPONSE:
      if (typeof action.payload === 'undefined') {
        return {
          ...state,
          fetched: true,
          fetching: false,
          newPatient: true,
          response: null,
        };
      }
      return {
        ...state,
        fetched: true,
        fetching: false,
        newPatient: false,
        response: action.payload,
      };

    case PARSE_RESPONSE:
      return {
        ...state,
        parsedResponse: action.payload,
      };
    case DTT_PARSE_RESPONSE:
      return {
        ...state,
        DTTParsedResponse: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case RESET_QUESTIONNAIRE:
      return {
        ...state,
        current: null,
        response: null,
        parsedResponse: null,
        fetching: false,
        fetched: false,
        fetchingEmptyQ: false,
        fetchedEmptyQ: false,
        newPatient: false,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/questionnaire.js